import {rYAxisBars} from "./y-axis-bars";
import {cFieldGroupAxes} from "../../../common/field-group-axes";

export const YAxesBars = (yAxisBar) => (yAxisBar ? Object.keys(yAxisBar).map((k) => rYAxisBars(k)) : []);
